import React, { useEffect } from "react";

import Main from '../components/News/Main'
import PressCenter from "../components/News/PressCenter";
import Innovative from "../components/News/Innovative";

function News () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return(
        <div className="bg-[#1D1D1D] relative overflow-hidden">
            <Main/>
            <PressCenter/>
            <Innovative/>
        </div>
    );
}

export default News;